<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
import firebase from '@/services/saleData'
import 'firebase/database'
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$store.commit('masterManagement/SET_MASTER',this.params.data);
      this.$store.commit('masterManagement/SET_POPUP',true);
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      firebase.database().ref().child(`master/${this.params.data.key}`).remove().then(() =>{
        this.showDeleteSuccess()
        this.$store.dispatch('masterManagement/fetchMasters').catch(err => { console.error(err) })
      });
      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Master Deleted',
        text: 'The selected master was successfully deleted'
      })
    }
  }
}
</script>
